import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-operating-mode-page',
  templateUrl: './operating-mode-page.component.html',
  styleUrls: ['./operating-mode-page.component.css']
})
export class OperatingModePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
